import { Box, Button, FormControl } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Form = styled(FormControl)`
  padding: 16px;
  display: flex;
`;

export const SubmitButton = styled(Button)`
  margin: 8px 0 8px 12px;
`;

export const AddBroadcastLayout = styled(Box)`
  flex-direction: column;
  margin-top: 20px;
`;
